/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Case_Contact_Has_ConversationInputs */

const en_api_error_case_contact_has_conversation = /** @type {(inputs: Api_Error_Case_Contact_Has_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts with conversations cannot be deleted.`)
};

const pt_br2_api_error_case_contact_has_conversation = /** @type {(inputs: Api_Error_Case_Contact_Has_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatos com conversas não podem ser excluídos.`)
};

/**
* | output |
* | --- |
* | "Contacts with conversations cannot be deleted." |
*
* @param {Api_Error_Case_Contact_Has_ConversationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_case_contact_has_conversation = /** @type {((inputs?: Api_Error_Case_Contact_Has_ConversationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Case_Contact_Has_ConversationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_case_contact_has_conversation(inputs)
	return pt_br2_api_error_case_contact_has_conversation(inputs)
});